import { useState, type FormEvent } from 'react';

interface Props {
  onSubmit: (entry: { date: string; weightKg: number; waistCm?: number; note?: string }) => Promise<void>;
}

function todayKey() {
  return new Date().toISOString().slice(0, 10);
}

export default function WeightEntryForm({ onSubmit }: Props) {
  const [date, setDate] = useState(todayKey());
  const [weightKg, setWeightKg] = useState('');
  const [waistCm, setWaistCm] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!weightKg) return;
    await onSubmit({
      date,
      weightKg: Number(weightKg),
      waistCm: waistCm ? Number(waistCm) : undefined,
    });
    setWeightKg('');
    setWaistCm('');
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '0.5rem', alignItems: 'end', flexWrap: 'wrap' }}>
      <label>
        Date
        <br />
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
      </label>
      <label>
        Weight (kg)
        <br />
        <input
          type="number"
          step="0.1"
          value={weightKg}
          onChange={(e) => setWeightKg(e.target.value)}
          required
        />
      </label>
      <label>
        Waist (cm, optional)
        <br />
        <input type="number" step="0.1" value={waistCm} onChange={(e) => setWaistCm(e.target.value)} />
      </label>
      <button type="submit">Add entry</button>
    </form>
  );
}
